module.exports = __webpack_public_path__ + "static/media/ahmad.d7e278c7.jpeg";